// src/contexts/MyContext.js
import React from 'react';

const SidebarContext = React.createContext();

export default SidebarContext;
